import type { ChatUiProductCheckout } from '@voll-intelligence/genui-contract';
import type { CheckoutDrawerProps } from './checkout_drawer.js';

/** O roster do bloco como o drawer o recebe. O dono do rateio é o do
 *  contrato do produto (`productContract`), não deduzido daqui. */
export function checkoutRoster({
  travelers,
  requesterId,
}: Pick<ChatUiProductCheckout, 'travelers' | 'requesterId'>): Pick<
  CheckoutDrawerProps,
  'travelers' | 'requesterId'
> {
  return {
    ...(travelers ? { travelers } : {}),
    ...(requesterId ? { requesterId } : {}),
  };
}
